export function getAvailableGiftcards(restaurantData) {
  if (!restaurantData) return [];

  const giftcards = new Set();

  const collect = (scheme) => {
    const schemeSettings = scheme?.schemeSettings || {};
    Object.values(schemeSettings || {}).forEach((day) => {
      if (day.giftcardsEnabled && Array.isArray(day.giftcards)) {
        day.giftcards.forEach((card) => {
          if (card && card.trim() !== '') {
            giftcards.add(card);
          }
        });
      }
    });
  };

  collect(restaurantData['openinghours-breakfast']);
  collect(restaurantData['openinghours-lunch']);
  collect(restaurantData['openinghours-dinner']);

  return Array.from(giftcards);
}


